import { CSSProperties, FC, ReactNode } from 'react';

interface GlowEffectProps {
  children: ReactNode;
  color?: string;
  radius?: number;
  intensity?: number;
  className?: string;
  useGradient?: boolean;
}

const GlowEffect: FC<GlowEffectProps> = ({
  children,
  color = '#00d4d4',
  radius = 40,
  intensity = 0.6,
  className = '',
  useGradient = true,
}) => {
  const containerStyle: CSSProperties = {
    position: 'relative',
    display: 'block',
    width: '100%',
    height: '100%',
    overflow: 'visible',
  };

  const glowStyle: CSSProperties = {
    position: 'absolute',
    top: -25,
    right: -25,
    bottom: -25,
    left: -25,
    pointerEvents: 'none',
    filter: `blur(${radius}px)`,
    opacity: intensity,
    zIndex: 0,
    borderRadius: '30px',
    backgroundImage: useGradient 
      ? 'linear-gradient(135deg, rgba(255,198,99,0.7) 0%, rgba(0,212,212,0.8) 100%)' 
      : 'none',
    backgroundColor: !useGradient ? color : 'transparent',
  };

  const contentStyle: CSSProperties = {
    position: 'relative',
    zIndex: 1,
    width: '100%',
    height: '100%',
  };

  return (
    <div style={containerStyle} className={className}>
      <div style={glowStyle} />
      <div style={contentStyle}>
        {children}
      </div>
    </div>
  );
};

export default GlowEffect; 